import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo1 from '../assets/img/core-img/logo-1.png';
import logo2 from '../assets/img/core-img/logo-2.png';

// Add custom styles for logo and navigation
const logoStyles = `
  .navbar-brand .logo-responsive {
    max-width: 275px !important;
    height: auto !important;
    width: auto !important;
  }

  @media (max-width: 768px) {
    .navbar-brand .logo-responsive {
      max-width: 230px !important;
    }
    .navbar-brand {
      margin-right: 0 !important;
    }
  }

  .navbar.sticky .navbar-brand .logo-responsive {
    max-width: 275px !important;
  }

  @media (max-width: 768px) {
    .navbar.sticky .navbar-brand .logo-responsive {
      max-width: 230px !important;
    }
  }

  /* Navigation menu spacing */
  .navbar-nav .nav-item {
    margin-left: 18px !important;
    margin-right: 18px !important;
  }

  .navbar-nav .nav-item:first-child {
    margin-left: 0 !important;
  }

  .navbar-nav .nav-item:last-child {
    margin-right: 0 !important;
  }

  @media (max-width: 991px) {
    .navbar-nav .nav-item {
      margin-left: 0 !important;
      margin-right: 0 !important;
      margin-bottom: 10px !important;
    }
  }
`;

export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsSticky(offset > 100);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    handleResize();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Inject custom styles
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = logoStyles;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  // Function to determine which logo to use
  const getLogoSrc = () => {
    if (isMobile) {
      return logo2; // Always use sticky logo for mobile
    }
    return isSticky ? logo2 : logo1; // Desktop behavior unchanged
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-white fixed-top ${isSticky ? 'sticky' : ''}`} id="banner">
      <div className="container">
        {/* Brand */}
        <Link className="navbar-brand" to="/">
          <img
            src={getLogoSrc()}
            alt="Ardent Translations Logo"
            className="logo-responsive"
          />
        </Link>

        {/* Toggler/collapsible Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#collapsibleNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar links */}
        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/about-us">About Us</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/services">Services</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/multilingual">Multilingual</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/faq">FAQ</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
